import { ApolloCache, gql } from '@apollo/client'

import { CreateIncidentNoteMediaMutation } from '@/graphql/generated/operations'

type CreatedIncidentNoteMedia = NonNullable<
  CreateIncidentNoteMediaMutation['createIncidentNoteMedia']
>['media']

/**
 * Writes the mutation-confirmed attachments onto the note so they render
 * immediately, before any refetch lands. Note the limits: the refetch is not
 * awaited, so a transiently stale refetch response can still overwrite this
 * write — the drawer's 3s poll reconciles it. A watertight guarantee needs an
 * IncidentNote.media typePolicy merge instead of write ordering. Shared twin
 * of the helper in add-note/utils/utils.ts — de-duplicated with the legacy
 * tree's removal.
 */
export const updateIncidentNoteMediaCache = (
  cache: ApolloCache<any>,
  incidentNoteId: string | undefined,
  media: CreatedIncidentNoteMedia
) => {
  if (!incidentNoteId || !media?.length) return

  const incidentNoteCacheId = cache.identify({
    __typename: 'IncidentNote',
    id: incidentNoteId,
  })
  if (!incidentNoteCacheId) return

  cache.writeFragment({
    data: { media: media.filter(Boolean) },
    fragment: gql`
      fragment IncidentNoteAttachments on IncidentNote {
        media {
          id
          url
          name
          mimeType
        }
      }
    `,
    id: incidentNoteCacheId,
  })
}
